function webpackEmptyAsyncContext(req) {
	return new Promise(function(resolve, reject) { reject(new Error("Cannot find module '" + req + "'.")); });
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";


//////////////////
// WEBPACK FOOTER
// D:/deliverproject/eatasiafood/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main